import { Plus } from "lucide-react";
import { useCollection } from "./useCollection";
import { ProductEditor } from "./ProductEditor";

const NEW_PRODUCT = {
  name: "New Product", description: "", price_note: "", template: "tshirt", active: false,
  sides: [{ key: "front", label: "Front", area: { x: 33, y: 24, w: 34, h: 40 } }],
  colors: [{ name: "Black", hex: "#151515", front_image: "", back_image: "" }],
};

export default function ProductsAdmin() {
  const { items, setItems, create, save, remove } = useCollection("products");
  const update = (id, k, v) => setItems((xs) => xs.map((x) => (x.id === id ? { ...x, [k]: v } : x)));
  return (
    <div>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h1 className="font-display text-4xl font-black uppercase">Design Studio Products</h1>
        <button className="btn-red !py-2" onClick={() => create({ ...NEW_PRODUCT, order: items.length })} data-testid="admin-add-product-button"><Plus className="h-4 w-4" />Add Product</button>
      </div>
      <p className="mt-2 text-sm text-slate-400">Products customers can preview their logo on. Each color can use the flat template or your own photo. The dashed box is where the customer's design starts.</p>
      <div className="mt-6 grid gap-5 xl:grid-cols-2">
        {items.map((p, i) => <ProductEditor key={p.id} p={p} i={i} update={update} save={save} remove={remove} />)}
      </div>
    </div>
  );
}
